import BillingsOrderForwardBillingsDownloadRequest, {
  BillingsOrderForwardBillingsDownloadRequestBillingStatus,
  BillingsOrderForwardBillingsDownloadRequestOrder,
} from "../../../../api/raily/billings/order-forward-billings/download/billings-order-forward-billings-download.request";
import BillingStatus from "../../../../types/billing-status";
import BillingsOrderForwardBillingsDownloadParams, {
  BillingsOrderForwardBillingsDownloadParamsOrder,
} from "./billings-order-forward-billings-download-params";

const createStatus = (
  status: BillingStatus | undefined,
): BillingsOrderForwardBillingsDownloadRequestBillingStatus | undefined => {
  switch (status) {
    case BillingStatus.CREATED:
      return BillingsOrderForwardBillingsDownloadRequestBillingStatus.CREATED;
    case BillingStatus.ACCEPTED:
      return BillingsOrderForwardBillingsDownloadRequestBillingStatus.ACCEPTED;
    case BillingStatus.REJECTED:
      return BillingsOrderForwardBillingsDownloadRequestBillingStatus.REJECTED;
    case BillingStatus.REOPENED:
      return BillingsOrderForwardBillingsDownloadRequestBillingStatus.REOPENED;
    case BillingStatus.REOPEN_REQUEST:
      return BillingsOrderForwardBillingsDownloadRequestBillingStatus.REOPEN_REQUEST;
    default:
      return undefined;
  }
};

const createOrder = (
  order: BillingsOrderForwardBillingsDownloadParamsOrder | undefined,
): BillingsOrderForwardBillingsDownloadRequestOrder | undefined => {
  switch (order) {
    case BillingsOrderForwardBillingsDownloadParamsOrder.HUMAN_ID_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.HUMAN_ID_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.HUMAN_ID_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.HUMAN_ID_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DISTANCE_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DISTANCE_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_RATE_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DISTANCE_RATE_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_RATE_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DISTANCE_RATE_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_AMOUNT_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DISTANCE_AMOUNT_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_AMOUNT_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DISTANCE_AMOUNT_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.HALTING_AMOUNT_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.HALTING_AMOUNT_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.HALTING_AMOUNT_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.HALTING_AMOUNT_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.HIGHWAY_CHARGE_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.HIGHWAY_CHARGE_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.HIGHWAY_CHARGE_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.HIGHWAY_CHARGE_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.TOTAL_AMOUNT_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.TOTAL_AMOUNT_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.TOTAL_AMOUNT_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.TOTAL_AMOUNT_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.BILLING_MODEL_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.BILLING_MODEL_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.BILLING_MODEL_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.BILLING_MODEL_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.CONSUMER_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.CONSUMER_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.CONSUMER_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.CONSUMER_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DATE_AT_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DATE_AT_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.DATE_AT_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.DATE_AT_DESC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.PRODUCER_ASC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.PRODUCER_ASC;
    case BillingsOrderForwardBillingsDownloadParamsOrder.PRODUCER_DESC:
      return BillingsOrderForwardBillingsDownloadRequestOrder.PRODUCER_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: BillingsOrderForwardBillingsDownloadParams,
): BillingsOrderForwardBillingsDownloadRequest => {
  return {
    consumer: params.consumer,
    humanId: params.humanId,
    order: createOrder(params.order),
    producer: params.producer,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
    status: createStatus(params.status),
    taxiCorporationId: params.taxiCorporationId,
  };
};

const billingsOrderForwardBillingsDownloadParamsFactory = {
  create,
};

export default billingsOrderForwardBillingsDownloadParamsFactory;
